class MailchimpForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#mc-embedded-subscribe-form');
    this.emailInput = this.querySelector('#mce-EMAIL');
    this.submitButton = this.querySelector('#mc-embedded-subscribe');
    this.errorResponse = this.querySelector('#mce-error-response');
    this.successResponse = this.querySelector('#mce-success-response');
    
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    // Clear previous responses
    this.clearResponses();
    
    // Validate email
    if (!this.validateEmail()) {
      return;
    }
    
    // Show loading state
    this.setLoadingState(true);
    
    // Submit form via AJAX
    this.submitForm();
  }

  validateEmail() {
    const email = this.emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email) {
      this.showError('Bitte geben Sie Ihre E-Mail-Adresse ein.');
      return false;
    }
    
    if (!emailRegex.test(email)) {
      this.showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      return false;
    }
    
    return true;
  }

  submitForm() {
    const formData = new FormData(this.form);
    const actionUrl = this.form.getAttribute('action');
    
    // Convert FormData to URLSearchParams for proper encoding
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      params.append(key, value);
    }
    
    // Use JSONP to bypass CORS restrictions with MailChimp
    const callbackName = 'mc_callback_' + Date.now();
    const script = document.createElement('script');
    
    // Create global callback function
    window[callbackName] = (data) => {
      this.handleResponse(data);
      // Clean up
      document.head.removeChild(script);
      delete window[callbackName];
    };
    
    // Modify the action URL to use JSONP
    const jsonpUrl = actionUrl.replace('/post?', '/post-json?') + '&c=' + callbackName + '&' + params.toString();
    
    script.src = jsonpUrl;
    script.onerror = () => {
      this.showError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
      this.setLoadingState(false);
      document.head.removeChild(script);
      delete window[callbackName];
    };
    
    document.head.appendChild(script);
  }

  handleResponse(data) {
    this.setLoadingState(false);
    
    if (data.result === 'success') {
      this.showSuccess('Vielen Dank! Du wurdest erfolgreich angemeldet.');
      this.form.reset();
    } else {
      // Extract error message from MailChimp response
      let errorMessage = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
      
      if (data.msg) {
        // Clean up MailChimp's error message formatting
        errorMessage = data.msg.replace(/^\d+\s*-\s*/, '').replace(/<[^>]*>/g, '');
        
        // Translate common MailChimp errors to German
        if (errorMessage.includes('already subscribed')) {
          errorMessage = 'Diese E-Mail-Adresse ist bereits angemeldet.';
        } else if (errorMessage.includes('valid email')) {
          errorMessage = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
        } else if (errorMessage.includes('required')) {
          errorMessage = 'Bitte füllen Sie alle erforderlichen Felder aus.';
        }
      }
      
      this.showError(errorMessage);
    }
  }

  showError(message) {
    this.errorResponse.innerHTML = message;
    this.errorResponse.style.display = 'block';
    this.successResponse.style.display = 'none';
  }

  showSuccess(message) {
    this.successResponse.innerHTML = message;
    this.successResponse.style.display = 'block';
    this.errorResponse.style.display = 'none';
  }

  clearResponses() {
    this.errorResponse.style.display = 'none';
    this.successResponse.style.display = 'none';
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.submitButton.disabled = true;
      this.submitButton.value = 'Wird gesendet...';
      this.submitButton.classList.add('loading');
    } else {
      this.submitButton.disabled = false;
      this.submitButton.value = 'Jetzt anmelden';
      this.submitButton.classList.remove('loading');
    }
  }
}

customElements.define('mailchimp-form', MailchimpForm);